<template>
  <div class="caseCenter">
    <div class="headImg">
      <img :src="`http://www.china-tillage.com:8000${headImg}`" alt=""  style="width:100%;"/>
    </div>
    <div class="containt">
      <!-- <div class="tabs">
        <ul>
          <li @click="tabsChecked(1)" :class="currentIndex == 1 ?'current':''">智慧园区</li>
          <li @click="tabsChecked(2)" :class="currentIndex == 2 ?'current':''">智慧景区</li>
          <li @click="tabsChecked(3)" :class="currentIndex == 3 ?'current':''">智慧机电</li>
        </ul>
      </div> -->
      <div class="proList">
        <div class="item" v-for="(item,index) in caseCenter" :key="index">
          <div class="img">
            <img :src="`http://www.china-tillage.com:8000${item.pic}`" alt="" style="width:100%;">
            <div class="introduce" v-html="item.content">
              <!-- 农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。 -->
            </div>
          </div>
          <p>{{item.title}}</p>
        </div>
        <!-- <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div>
        <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div>
        <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div>
        <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div>
        <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div>
        <div class="item">
          <div class="img">
            <div class="introduce">
              农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与智慧管理完美结合的智慧景区农耕文化与
              智慧管理完美结合的智慧景区。
            </div>
          </div>
          <p>乡愁贵州智慧景区</p>
        </div> -->
        <!-- 清除浮动 -->
        <div style="clear:both;"></div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { baseURL } from "../../../config.ts"

export default {
  name: 'caseCenter',
  data() {
    return {
      currentIndex: 1,
      caseCenter: [],
      headImg: "",
      baseURL:null,
    }
  },
  components: {},
  mounted() {
    this.baseURL = baseURL
    this.getheadImg()
    this.getCasePark()
  },
  methods: {
    // 获取新闻大图
    getheadImg(){
      this.$http.get(`${baseURL}/json/img/case`).then( (res)=>{
          // console.log(res,"头部图片")
          this.headImg = res.data.pic
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    tabsChecked(index){
      this.currentIndex = index
      if(index == 1){
        this.getCasePark()
      }else if(index == 2){
        // this.getCaseScenic()
      }else if(index == 3){
        // this.getCaseMachine()
      }
    },
    // 获取智慧园区数据
    getCasePark(){
      this.$http.get(`${baseURL}/json/case`).then( (res)=>{
          // console.log(res,"园区")
          this.caseCenter = res.data
        }
      ).catch((err)=>{
        console.log(err)
      })
    },
    // // 智慧景区
    // getCaseScenic(){
    //   this.$http.get(`${baseURL}/json/case/scenic`).then( (res)=>{
    //       // console.log(res,"景区")
    //       this.caseCenter = res.data
    //     }
    //   ).catch((err)=>{
    //     console.log(err)
    //   })
    // },
    // // 智慧机电
    // getCaseMachine(){
    //   this.$http.get(`${baseURL}/json/case/machine`).then( (res)=>{
    //       // console.log(res,"机电")
    //       this.caseCenter = res.data
    //     }
    //   ).catch((err)=>{
    //     console.log(err)
    //   })
    // },
  },
}
</script>

<style lang="scss" scope>
* {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.caseCenter{
  .headImg {
    width: 100%;
    // height: 656px;
    overflow: hidden;
  }
  .containt{
    // width: 60%;
    width: 1200px;
    padding: 20px 0%;
    margin: 0 auto;
    .tabs{
      ul{
        width: 40%;
        margin: 0px auto;
        margin-top: 100px;
        display: flex;
        justify-content: space-around;
        li{
          width: 100px;
          font-size: 14px;
          line-height: 20px;
          color: #3488ea;
          background: #ffffff;
          border: 1px solid #3488ea;
          border-radius: 32px;
          cursor: pointer;
        }
        li.current{
          color: #ffffff;
          background: #3488ea;
        }
      }
    }
    .proList{
      padding: 60px 0;
      .item{
        width: 280px;
        height: 260px;
        margin-right: 20px;
        margin-bottom: 30px;
        float: left;
        cursor: pointer;
        .img{
          width: 100%;
          height: 220px;
          // background: rgba(8,17,60,0.50);
          position: relative;
          overflow: hidden;
          .introduce{
            width: 90%;
            height: 180px;
            padding: 20px 5%;
            font-size: 14px;
            text-align: left;
            text-indent: 14px;
            color: #ffffff;
            line-height: 20px;
            position: absolute;
            top: 220px;
            // background-color: #3488ea;
            background-color: rgb(52,136,234,0.5);
            // opacity: 0.8;
            transition: top 0.2s ease-out;
            display: flex;
            align-items: center;
          }
        }
        .img:hover .introduce{
          top: 0px;
        }
        p{
          padding: 10px 0;
          font-size: 14px;
          font-weight: 700;
          color: #040f36;
        }
      }
    }
  }
}
</style>